<template>
  <svg
    :width="size"
    :height="size" viewBox="0 0 28 20"
    :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.92268 20.0001L0.442383 10.5198L2.81246 8.14973L9.92268 15.2599L25.1826 0L27.5527 2.37007L9.92268 20.0001Z"/>
  </svg>
</template>

<script>
export default {
  name: "CheckIcon",
  props: {
    fill: {
      type: String,
      default: 'inherit'
    },
    size: {
      type: [String, Number],
      default: 20
    }
  }
}
</script>
